// src/components/productDetail/ContentStructureBlock.tsx - CORRIGIDO

import React, { useState, useEffect, useCallback } from 'react';
import { ChevronDown, ChevronUp, Package } from 'lucide-react';
import './ContentStructureBlock.css';

interface DeckStructure {
    _id: string;
    name: string;
    totalCards: number;
    subdecks: {
        _id: string;
        name: string;
        cardCount: number;
    }[];
}

interface ContentStructureBlockProps {
    deckIds: string[];
}

export const ContentStructureBlock: React.FC<ContentStructureBlockProps> = ({ deckIds }) => {
    const [structures, setStructures] = useState<DeckStructure[]>([]);
    const [expanded, setExpanded] = useState<{ [key: string]: boolean }>({});
    const [loading, setLoading] = useState(true);

    const loadStructures = useCallback(async () => {
        try {
            setLoading(true);

            const promises = deckIds.map(deckId =>
                fetch(`/api/admin/marketplace/decks/${deckId}/structure/public`, {
                }).then(res => res.ok ? res.json() : null)
            );

            const results = await Promise.all(promises);
            const validStructures = results
                .filter(r => r && r.structure)
                .map(r => r.structure);

            setStructures(validStructures);
        } catch (error) {
            console.error('Erro ao carregar estruturas:', error);
        } finally {
            setLoading(false);
        }
    }, [deckIds]);

    useEffect(() => {
        loadStructures();
    }, [loadStructures]);

    const toggleExpand = (deckId: string) => {
        setExpanded(prev => ({ ...prev, [deckId]: !prev[deckId] }));
    };

    if (loading) {
        return (
            <div className="csb-container">
                <div className="csb-loading">Carregando estrutura...</div>
            </div>
        );
    }

    if (structures.length === 0) {
        return null;
    }

    return (
        <div className="csb-container">
            <h3 className="csb-title">Estrutura do Conteúdo</h3>

            <div className="csb-deck-list">
                {structures.map(deck => {
                    const isExpanded = expanded[deck._id];

                    return (
                        <div key={deck._id} className="csb-deck-card">
                            {/* Header */}
                            <button
                                className="csb-deck-header"
                                onClick={() => toggleExpand(deck._id)}
                            >
                                <div className="csb-deck-info">
                                    <Package size={20} className="csb-deck-icon" />
                                    <div>
                                        <div className="csb-deck-name">{deck.name}</div>
                                        <div className="csb-deck-total">
                                            {deck.totalCards} flashcards • {deck.subdecks.length} módulos
                                        </div>
                                    </div>
                                </div>
                                <div className="csb-expand-icon">
                                    {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                                </div>
                            </button>

                            {/* Subdecks */}
                            {isExpanded && (
                                <div className="csb-subdeck-list">
                                    {deck.subdecks.map(subdeck => (
                                        <div key={subdeck._id} className="csb-subdeck-item">
                                            <span className="csb-subdeck-name">{subdeck.name}</span>
                                            <span className="csb-subdeck-count">{subdeck.cardCount} cards</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};